import * as React from "react";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  leaderboardsActions,
  orgActions,
  AppDispatch,
  RootState,
} from "../redux";
import {
  faBriefcase,
  faUsers,
  faAward,
  faRunning,
} from "@fortawesome/free-solid-svg-icons";

import Avatar from "../components/Avatar";
import HealthLeaderboardCard, {
  getDisplayName,
} from "../components/health-leaderboard-card";
import TileWithDateRange from "../components/tile-with-date-range";
import SquareButtonWithText from "../components/square-button-with-text";
import RoundIconLabels from "../components/round-icon-labels";
import PeriodModifier from "../components/period-modifier";
import LoaderSvg from "../components/loader-svg";

import { YODHA_COLORS } from "../constants/colours";
import { images } from "../constants/images/images-resolved";
import { formatOrdinalNumber } from "../utils/utilFunctions";
import { LeaderboardsData, LedearboardType } from "../constants/types";
import axios from "axios";
import { envConfig } from "../constants/config";

const LeaderBoardPage = () => {
  const dispatch: AppDispatch = useDispatch();
  const { id } = useParams();
  const Navigate = useNavigate();
  const leaderboardError = useSelector((x: RootState) => x.leaderboards.error);
  const {
    loading: orgLoading,
    org_logo,
    org_name,
    error: orgError,
  } = useSelector((x: RootState) => x.org);
  const authInfo = useSelector((x: RootState) => x.auth.user);

  const leaderboards = useSelector(
    (x: RootState) => x.leaderboards.leaderboards
  );
  const slug = useSelector((x: RootState) => x.leaderboards.slug);

  const [type, setType] = React.useState<LedearboardType>("organisation"); // organisation //top-teams
  const [currentView, setCurrentView] =
    React.useState<dayjs.ManipulateType>("day"); // month week
  const [isCurrent, setIsCurrent] = React.useState(true);

  React.useEffect(() => {
    if (orgError || leaderboardError) Navigate("/");
  }, [orgError, leaderboardError]);

  React.useEffect(() => {
    console.log(id, "id router id");
    console.log(slug, "slug");
    if (slug) dispatch(orgActions.getOrg());
  }, [slug]);

  React.useEffect(() => {
    dispatch(
      leaderboardsActions.getLeaderboards({
        url: type,
        period: currentView,
        isCurrent,
        orgId: id ?? "",
      })
    );
  }, [type, currentView, isCurrent, authInfo]);

  const firstLabel = org_name ?? "N/A";

  const secondLabel = `${
    leaderboards.length > 0 ? getDisplayName(leaderboards[0].name ?? "") : ""
  } is in ${formatOrdinalNumber(1)} place`;

  return (
    <div className="grid gap-10 grid-cols-1 md:grid-cols-2 p-3">
      <div className="flex flex-row items-center mt-4">
        {/* <SquareButtonWithText
            active={type === "team"}
            imgSrc={images.your_team}
            text={"Your Team"}
            onClick={() => setType("team")}
          /> */}
        <SquareButtonWithText
          active={type === "organisation"}
          imgSrc={images.the_company}
          text={"The Company"}
          onClick={() => setType("organisation")}
        />
        <SquareButtonWithText
          active={type === "top-teams"}
          imgSrc={images.top_team}
          text={"Top Teams"}
          onClick={() => setType("top-teams")}
        />

        <img src={org_logo} className="h-14 ml-10" />

        {/* <FontAwesomeIcon
          icon={faPowerOff}
          size={"2x"}
          color={"red"}
          className="cursor-pointer ml-5"
          onClick={() => dispatch(authActions.logout())}
        /> */}
      </div>

      <PeriodModifier
        setCurrentView={setCurrentView}
        currentView={currentView}
      />

      <div>
        <div
          className="flex flex-row  items-center shadow-lg p-4 rounded"
          style={{ width: "100%" }}
        >
          {leaderboards.length > 0 && (
            <Avatar
              fullName={leaderboards[0]?.name ?? ""}
              url={leaderboards[0]?.photo_url ?? ""}
              className="rounded-full w-24 h-24 border-4 border-gray-300"
            />
          )}

          <div className="ml-5 flex flex-col justify-center">
            <RoundIconLabels
              labelText={firstLabel}
              borderColor="border-yellow-300"
              colorValue={YODHA_COLORS.greyAlt}
              icon={type === "organisation" ? faBriefcase : faUsers}
              size={"1x"}
            />

            {leaderboards.length > 0 && (
              <RoundIconLabels
                labelText={secondLabel}
                borderColor="border-green-300"
                colorValue={YODHA_COLORS.greyAlt}
                icon={faAward}
                size={"1x"}
              />
            )}
            {leaderboards.length > 0 && (
              <RoundIconLabels
                labelText={leaderboards[0].step_count ?? "0"}
                borderColor="border-blue-300"
                colorValue={YODHA_COLORS.greyAlt}
                icon={faRunning}
                size={"1x"}
              />
            )}
          </div>
        </div>

        {/* <div className="w-full h-3 shadow-lg mt-2" /> */}
      </div>

      <div>
        <TileWithDateRange
          centered
          isCurrent={isCurrent}
          setIsCurrent={setIsCurrent}
          hasArrows
          dateRangeFontSize={20}
          headerFontSize={16}
          dateType={currentView}
        />

        {orgLoading && (
          <div className="flex justify-center mt-5">
            <LoaderSvg bgColor={YODHA_COLORS.grey} />
          </div>
        )}

        <div>
          {leaderboards.map((v: LeaderboardsData, i: number) => (
            <HealthLeaderboardCard
              name={v?.name ?? ""}
              image={v?.photo_url ?? ""}
              place={i + 1}
              steps={v?.step_count ?? ""}
              backgroundColor={i % 2 === 1 ? "#FFF" : "#F6F7F8"}
              isTopTeamView={type === "top-teams"}
              key={v?.user_id}
              type={type}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeaderBoardPage;
